import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import AccountsPackItemForm from '../../../components/forms/AccountsPackItemForm';
import { useAccountsPackItemApi } from '../../../hooks/useAccountsPackItemApi';
import { useNavigate } from 'react-router-dom';
import { AccountsPackItemDTO } from '../../../services/apiClient';

const AccountsPackItemCreate: React.FC = () => {
  const { create, isLoading } = useAccountsPackItemApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Accounts Pack Items', href: '/admin/accountspackitems' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: AccountsPackItemDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/accountspackitems');
    } catch (error) {
      console.error('Error creating AccountsPackItem:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/accountspackitems"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.AccountsPackItem.Edit'
    >
        <AccountsPackItemForm
          initialValues={{} as AccountsPackItemDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/accountspackitems')}
          isLoading={isSubmitting}
        />
    </AdminLayout>
  );
};

export default AccountsPackItemCreate;